module.exports = __webpack_public_path__ + "static/polarbear-eb89357ecc10afb9cc72bc652ba63919.gif";